import LogoVertical from "../../images/LogoVertical";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useEffect, useState } from "react";
import Api from "../../Api";
import { useParams } from "react-router-dom";
import { intToBrl } from "../../utils";
import moment from "moment";
import { Receipt } from "../../types";

type Data = {
  receipt: Receipt;
  clientName: string;
};
const GenericReceipt = () => {
  const { hash } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Data | null>(null);

  useEffect(() => {
    Api.externalGetGenericReceipt(hash!)
      .then(setData)
      .then(() => setLoading(false));
  }, [hash]);

  if (loading)
    return (
      <div className="h-screen flex items-center">
        <div className="w-full text-center text-4xl">
          <FontAwesomeIcon icon="circle-notch" spin={true} />
        </div>
      </div>
    );

  if (!data)
    return (
      <div className="h-screen flex items-center">
        <div className="w-full text-center text-xl">Recibo não encontrado</div>
      </div>
    );

  return (
    <div className="flex flex-col items-center gap-4 max-w-xs m-auto py-8">
      <LogoVertical />

      <div className="w-full border-b-4 border-dashed"></div>

      <div className="w-full">
        <div className="text-xs font-extralight">Recebemos de</div>
        <div className="font-bold">{data.clientName}</div>
      </div>

      <div className="w-full">
        <div className="text-xs font-extralight">A quantia de</div>
        <div className="font-bold">{intToBrl(data.receipt.amount)}</div>
      </div>

      <div className="w-full">
        <div className="text-xs font-extralight">Na data</div>
        <div className="font-bold">
          {moment.utc(data.receipt.date).format("DD/MM/YYYY")}
        </div>
      </div>

      <div className="w-full">
        <div className="text-xs font-extralight mb-1">Referente a</div>
        <div className="font-semibold leading-4">{data.receipt.reference}</div>
      </div>

      <div className="w-full border-b-4 border-dashed my-2"></div>

      <div className="text-xs leading-3 text-gray-500 tracking-tight text-center">
        Rua Profa. Zilda Andrade, 57
        <br />
        Bairro de Lourdes, Vitória, ES
        <br />
        27 3232-1000
        <br />
        <br />
        financeiro@alarmsystem.com.br
      </div>

      <div className="text-center mb-16 print:hidden">
        <a
          href="https://www.instagram.com/alarmsystem.es/"
          target="_blank"
          rel="noreferrer"
          className="text-2xl px-2 text-gray-500 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>

        <a
          href="https://wa.me/5527999481419"
          target="_blank"
          rel="noreferrer"
          className="text-2xl px-2 text-gray-500 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
    </div>
  );
};

export default GenericReceipt;
